<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{ 'onboarding.website_access.title' | translate }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <div class="row justify-content-center">
    <div class="col-12">
      <p>
        {{ 'onboarding.website_access.intro_before_email' | translate }}
        <a href="mailto:data@connectreporting.com">data&#64;connectreporting.com</a>.
        {{ 'onboarding.website_access.intro_after_email' | translate }}
      </p>
    </div>

    <!-- Button Selection -->
    <div class="col-12 mb-3 mt-5" *ngIf="selectedOption === null">
      <div class="row g-3">
        <div class="col-6">
          <button type="button" class="btn btn-outline-primary w-100" (click)="selectGoogleLogin()">
            <i class="fas fa-user me-2"></i>{{ 'onboarding.website_access.button_create_user' | translate }}
          </button>
        </div>
        <div class="col-6">
          <button type="button" class="btn btn-outline-primary w-100" (click)="selectCredentials()">
            <i class="fas fa-key me-2"></i>{{ 'onboarding.website_access.button_provide_credentials' | translate }}
          </button>
        </div>
      </div>
    </div>

    <!-- Credentials Form -->
    <div class="col-8 mb-5" *ngIf="selectedOption === 'credentials'">
      <app-website-access [inputAccountTypes]="[customerAccountTypes.CMSAdminAccess]" [hideHelpText]="true"
        (credentialsSaved)="credentialsProvided()"></app-website-access>
    </div>

    <!-- User Created Confirmation -->
    <div class="col-8 my-5" *ngIf="selectedOption === 'crmInvite'">
      <div class="alert alert-primary" role="alert">
        <h5 class="alert-heading">{{ 'onboarding.website_access.confirm_user_heading' | translate }}</h5>
        <p>{{ 'onboarding.website_access.confirm_user_body' | translate }}</p>
        <hr>
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-primary" (click)="credentialsProvided()" [disabled]="loading">
            {{ 'shared.button_confirm' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
